import { TextField } from "@mui/material"
import { useContext, useState } from "react";
import { DraftContext } from "../../../context/DraftContext";
import { TYPES } from "../../../../../config/constants/typesReducers";

export const SubjectForm = () => {
  const { draftState:{ draft }, draftDispatch } = useContext(DraftContext);
  const { subject: { header, description } } = draft;
  
  const [subject, setSubject] = useState({
    header: header ? header : '',
    description: description ? description : ''
  });

  const handleEditField = ({target}) => {
    const {name, value} = target;

    //console.log(name, value);
    setSubject({
      ...subject,
      [name]: value
    });
  }

  const handleBlurField = () => {
    draftDispatch({
      type: TYPES.DRAFT.SUBJECT,
      payload: subject
    })
  }

  return (
    <>
      <p className="md-text grey-text">Asunto *</p>
      <TextField 
        required
        defaultValue={subject.header}
        placeholder="Asunto"
        name="header" 
        className="input"
        color="primary"
        variant="outlined"
        margin="normal"
        fullWidth 
        onChange={handleEditField}
        onBlur={handleBlurField}
      />
      <br />
      <br />
      <p className="md-text grey-text">Cuerpo del mensaje</p>
      <TextField
        placeholder="Descripción"
        onBlur={handleBlurField}
        defaultValue={subject.description}
        name="description"
        className="input"
        margin="normal"

        color="primary"
        fullWidth
        multiline
        rows={5}
        onChange={handleEditField}
        />
    </>
  )
}